<!--
// app/pages/index.vue
-->
<script setup lang="ts">
import MainGradientDivider from "~/app/components/context-shared/MainGradientDivider.vue";
import BannerCompetitionName from "~/app/components/context-shared/BannerCompetitionName.vue";
import GridNewsHero from "~/app/components/Shared/GridNewsHero.vue";
import TableStandingHome from "~/app/components/pages/region-home/TableStandingHome.vue";
import GridFeaturedStatsHome from "~/app/components/pages/region-home/GridFeaturedStatsHome.vue";
import { LazyGridPartnersCompetition, LazyPagesRegionHomeSectionVideosYoutubeHome } from "#components";
import CurrentSeasonSliderMatches from "~/app/components/Shared/slider-matches/CurrentSeasonSliderMatches.vue";
import BannerFullWidthCms from "~/app/components/pages/region-home/BannerFullWidthCms.vue";
import { useRegions } from "~/app/composables/regions";
import { useWebContext } from "~/app/composables/webContext";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import BaseLivePopup from "~/app/components/base/BaseLivePopup.vue";
import KokQualifiersSpain from "~/app/pages/[region]/qualifiers/KokQualifiersSpain.vue";
import TablesBracketHome from "~/app/components/pages/region-home/TablesBracketHome.vue";
import CurrentPlayoffBracket from "~/app/components/pages/region-home/CurrentPlayoffBracket.vue";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]",
    es: "/[region]",
    de: "/[region]",
    fr: "/[region]",
    it: "/[region]",
    pt: "/[region]",
    ar: "/[region]",
  },
});

const { t } = useI18n();
const { isAmericas, isWorldCup, isNations, isKokNations } = useRegions();
const { contextSiteTitle, isQueens, contextDomain, webContext, isKings } = useWebContext();
const { region, currentSeason } = useCompetitionStore();
const localePath = useLocalePath();

useSeoMeta({
  titleTemplate: isNations
    ? `${region.leagueTitle} 2025`
    : isWorldCup
      ? `${region.leagueTitle} 2025`
      : region.leagueTitle,
  ogTitle: isQueens ? t("site.description.queens") : t("site.description.kings"),
  description: t("meta.description.home.page", { regionLeagueTitle: region.leagueTitle }),
  ogDescription: t("meta.description.home.page", { regionLeagueTitle: region.leagueTitle }),
});

const regionSocial =
  !!region?.social && region.social ? JSON.stringify(region.social?.map(social => social.url)) : null;

useHead({
  script: () => [
    {
      type: "application/ld+json",
      innerHTML: `{"@context": "https://schema.org","@type": "WebSite","name": "${contextSiteTitle}", "url": "https://${contextDomain}", "sameAs" : ${regionSocial}}`,
      key: "webSchema",
    },
  ],
});
</script>

<template>
  <div v-if="isKokNations">
    <kok-qualifiers-spain></kok-qualifiers-spain>
  </div>

  <div v-else-if="isNations || isWorldCup">
    <banner-competition-name></banner-competition-name>
    <div>
      <banner-full-width-cms></banner-full-width-cms>
      <div class="relative">
        <current-season-slider-matches></current-season-slider-matches>
      </div>
      <main-gradient-divider height="h-2.5"></main-gradient-divider>
      <grid-news-hero see-more-button></grid-news-hero>
      <section class="kql-w-container py-6 xl:px-0 grid grid-cols-1 gap-4">
        <div class="px-4 lg:px-0">
          <tables-bracket-home></tables-bracket-home>
        </div>

        <div class="md:px-4 lg:px-0">
          <grid-featured-stats-home></grid-featured-stats-home>
        </div>
      </section>
      <LazyIdlePagesRegionHomeSectionVideosYoutubeHome hydrate-on-idle />
      <LazyVisibleGridPartnersCompetition hydrate-on-visible />
    </div>
  </div>

  <div v-else>
    <banner-competition-name></banner-competition-name>
    <div>
      <banner-full-width-cms></banner-full-width-cms>
      <div class="relative">
        <current-season-slider-matches></current-season-slider-matches>
      </div>
      <main-gradient-divider height="h-2.5"></main-gradient-divider>
      <grid-news-hero see-more-button></grid-news-hero>

      <current-playoff-bracket></current-playoff-bracket>

      <section class="kql-w-container py-6 xl:px-0 grid grid-cols-1 lg:grid-cols-4">
        <div class="px-4 lg:px-0">
          <table-standing-home></table-standing-home>
        </div>
        <div class="lg:col-span-3 lg:ms-4 md:px-4 lg:px-0">
          <grid-featured-stats-home></grid-featured-stats-home>
        </div>
      </section>
      <LazyIdlePagesRegionHomeSectionVideosYoutubeHome hydrate-on-idle />
      <LazyVisibleGridPartnersCompetition hydrate-on-visible />
    </div>
  </div>

  <base-live-popup class-window-position="bottom-4 right-4"></base-live-popup>
</template>

<style scoped></style>
